import { createSlice } from '@reduxjs/toolkit';

import { assignDefinedFields } from '@polyai/stream/store/utils/assign-fields';
import { assignMetadata } from '@polyai/stream/store/utils/assign-metadata';

import { deleteFunction } from '../../functions/actions';
import { deleteTranslation } from '../../translations/actions';
import { updateRules } from '../actions';
import { RULES_INITIAL_STATE } from '../constants';

const slice = createSlice({
  name: 'rules',
  initialState: RULES_INITIAL_STATE,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(updateRules, (state, action) => {
      assignDefinedFields(state, action.payload);
      assignMetadata(action, state);
    });

    builder.addCase(deleteFunction, (state, action) => {
      const { id: functionId } = action.payload;
      if (state.references.globalFunctions[functionId]) {
        delete state.references.globalFunctions[functionId];
      }
      assignMetadata(action, state);
    });

    builder.addCase(deleteTranslation, (state, action) => {
      const { id: translationId } = action.payload;
      if (state.references.translations?.[translationId]) {
        delete state.references.translations[translationId];
      }
    });
  },
});

export default slice.reducer;
